export class IndexedDB {

    constructor() {
        const dbName = 'Shopping-list',
            dbVersion = 1,
            dbUpgrade = (db, oldVersion, newVersion) => {
                console.log(`upgrading database from ${oldVersion} to ${newVersion}`);
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore('list');
                        break;
                    default:
                        break;
                }
            };

        return new Promise((resolve, reject) => {
            this.db = null;

            if (!('indexedDB' in window)) reject('not supported');

            const dbOpen = indexedDB.open(dbName, dbVersion);

            if (dbUpgrade) {
                dbOpen.onupgradeneeded = e => {
                    dbUpgrade(dbOpen.result, e.oldVersion, e.newVersion);
                };
            }

            dbOpen.onsuccess = () => {
                this.db = dbOpen.result;
                resolve(this);
            };

            dbOpen.onerror = e => {
                reject(`IndexedDB error: ${e.target.error}`);
            };
        });
    }

    set(storeName, item, key) {
        return new Promise((resolve, reject) => {
            const
                transaction = this.db.transaction(storeName, 'readwrite'),
                store = transaction.objectStore(storeName);

            store.put(item, key);

            transaction.oncomplete = () => {
                window.localStorage.setItem('lastEdited', +new Date());
                resolve(true);
            };

            transaction.onerror = () => {
                reject(`set method error: ${transaction.error}`);
            };
        });
    }

    setAll(storeName, items, lastEdited) {
        return new Promise((resolve, reject) => {
            const
                transaction = this.db.transaction(storeName, 'readwrite'),
                store = transaction.objectStore(storeName);

            items.forEach(item => {
                store.put(item, item.id);
            });

            transaction.oncomplete = () => {
                window.localStorage.setItem('lastEdited', lastEdited);
                resolve(true);
            };

            transaction.onerror = () => {
                reject(`set method error: ${transaction.error}`);
            };
        });
    }

    get(storeName, name) {
        return new Promise((resolve, reject) => {
            const
                transaction = this.db.transaction(storeName, 'readonly'),
                store = transaction.objectStore(storeName),
                request = store.get(name);

            request.onsuccess = () => {
                resolve(request.result);
            };

            request.onerror = () => {
                reject(`get method error: ${request.error}`);
            };
        });
    }

    getAll(storeName) {
        return new Promise((resolve, reject) => {
            const
                transaction = this.db.transaction(storeName, 'readonly'),
                store = transaction.objectStore(storeName),
                request = store.getAll();

            request.onsuccess = () => {
                resolve(request.result);
            };

            request.onerror = () => {
                reject(`getAll method error: ${request.error}`);
            };
        });
    }

    delete(storeName, name) {
        return new Promise((resolve, reject) => {
            const
                transaction = this.db.transaction(storeName, 'readwrite'),
                request = transaction.objectStore(storeName).delete(name);

            request.onsuccess = () => {
                window.localStorage.setItem('lastEdited', +new Date());
                resolve(request.result);
            };

            request.onerror = () => {
                reject(`delete method error: ${request.error}`);
            };
        });
    }

    clear(storeName) {
        return new Promise((resolve, reject) => {
            const
                transaction = this.db.transaction(storeName, 'readwrite'),
                request = transaction.objectStore(storeName).clear();

            request.onsuccess = () => {
                resolve(request.result);
            };

            request.onerror = () => {
                reject(`clear method error: ${request.error}`);
            };
        });
    }
}